import React from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
} from '@mui/material';
import Loading from '../table-elements/loading.component';
import NoData from '../table-elements/no-data.component';
import Error from '../table-elements/error.component';
import CELL_DATA_TYPES from '../../config/cell-types.config';
import { getPlatformLabel } from '../../config/platforms.config';
import { formatNumber } from '../../utils/numbers.util';

const EngagementPlatformTable = ({ columns, data, loading, error }) => (
  <TableContainer>
    <Table size="small">
      <TableHead>
        <TableRow>
          {columns.map((c, i) => (
            <TableCell
              key={i}
              align={c.align}
              sx={{
                bgcolor: '#F4F6F8',
                color: '#637381',
                fontWeight: 600,
                paddingY: '8px',
                fontSize: '13px',
              }}
            >
              {c.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>

      <TableBody>
        {!loading &&
          !error &&
          data.map((row, index) => (
            <TableRow key={row.platform || index} hover>
              {columns.map((c) => (
                <TableCell
                  align={c.align}
                  sx={{ paddingY: '10px', fontSize: '13px', fontWeight: 600 }}
                >
                  {c.type === CELL_DATA_TYPES.PLATFORM
                    ? getPlatformLabel(row[c.dataKey])
                    : formatNumber(row[c.dataKey])}
                </TableCell>
              ))}
            </TableRow>
          ))}

        {!loading && !error && data.length === 0 && (
          <TableRow>
            <TableCell align="center" colSpan={columns.length} sx={{ py: 3 }}>
              <NoData />
            </TableCell>
          </TableRow>
        )}

        {!loading && error && (
          <TableRow>
            <TableCell align="center" colSpan={columns.length} sx={{ py: 3 }}>
              <Error />
            </TableCell>
          </TableRow>
        )}

        {loading && (
          <TableRow>
            <TableCell align="center" colSpan={columns.length} sx={{ py: 3 }}>
              <Loading />
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  </TableContainer>
);

EngagementPlatformTable.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
};

export default EngagementPlatformTable;
